import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk for fetching assigned jobs
export const fetchAssignedJobs = createAsyncThunk(
  'jobs/fetchAssignedJobs',
  async (_, { rejectWithValue }) => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    if (!ticketToken) {
      return rejectWithValue('No ticket token found in sessionStorage');
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/applicant/get-assigned-jobs`,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
      console.log('Response Data:', response.data);
      return response.data.data; // Assuming the data is in response.data.data
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    assignedJobs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignedJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssignedJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedJobs = action.payload;
      })
      .addCase(fetchAssignedJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch assigned jobs';
      });
  },
});

// Export the reducer as default
export default jobsSlice.reducer;
